import { useEffect, useState } from 'react';

export const LIVE_DATA_TIMEOUT_MS = 15000; // 15 sec

export interface UseLiveDataTimeoutReturn {
  isTimedOut: boolean;
  lastReceivedAt?: Date;
}

export const useLiveDataTimeout = (message: unknown, timeoutMs = LIVE_DATA_TIMEOUT_MS): UseLiveDataTimeoutReturn => {
  const [isTimedOut, setIsTimedOut] = useState(false);
  const [lastReceivedAt, setLastReceivedAt] = useState<Date>();

  useEffect(() => {
    if (message !== undefined) {
      setLastReceivedAt(new Date());
    }
    setIsTimedOut(false);

    const timeoutId = setTimeout(() => setIsTimedOut(true), timeoutMs);
    return () => clearTimeout(timeoutId);
  }, [message, timeoutMs]);

  return { isTimedOut, lastReceivedAt };
};
